/**
 * @param {string | null | undefined} dateString ISO / Contentful datetime
 * @returns {string} DD/MM/YYYY or empty when missing / invalid parse
 */
export function formatBlogPublishedDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}
